"use client";

import React, { useEffect, useState } from "react";
import CommonCustomSVG, { CustomSVGProps } from "./CustomSVG";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";

export const CustomSVG: React.FC<CustomSVGProps> = (props) => {
  const { fallback = null } = props;

  const { getIcon } = useGlobalContext();

  const src = "src" in props ? props.src : getIcon(props.iconKey);

  // icons inlined on the server come as svg markup - no fetch needed
  const isSvgString = !!src?.trimStart().startsWith("<svg");

  const [svgContent, setSvgContent] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    if (isSvgString) return;

    if (!src) {
      setSvgContent(null);
      return;
    }

    const fetchSVG = async () => {
      try {
        const response = await fetch(src);
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.statusText}`);
        }
        const text = await response.text();
        if (isMounted) {
          setSvgContent(text);
          setError(false);
        }
      } catch (err) {
        console.error("Error fetching SVG:", err);
        if (isMounted) {
          setError(true);
        }
      }
    };

    fetchSVG();

    return () => {
      isMounted = false;
    };
  }, [src, isSvgString]);

  if (isSvgString && src) {
    return <CommonCustomSVG {...props} svgContent={src} />;
  }

  if (error || !svgContent) {
    return <>{fallback}</>;
  }

  return <CommonCustomSVG {...props} svgContent={svgContent} />;
};

export default CustomSVG;
